<template>
  <div>
    <div class="loginbg">
      <div class="app-down" @click="downloadShow = !downloadShow">
        <div class="icon"><img src="../../assets/images/rightApp.png" /></div>
        <div class="down-text">APP下载</div>
      </div>
      <div class="app-content" v-if="downloadShow">
        <div class="app-item">
          <div class="download-code"><img src="../../assets/images/download-weixin.jpg" /></div>
          <div class="app-text">关注微信公众号</div>
        </div>
        <div class="app-item">
          <div class="download-code"><img src="../../assets/images/download-anzhuo.png" /></div>
          <div class="app-text">IOS/Android</div>
        </div>
      </div>
      <div class="page-width">
        <div class="logins">
          <div class="login-top">
            <img :src="logoUrl" />
            <div class="login-top-str">{{ loginTopStr }}</div>
          </div>
          <div
              class="mainscontainer"
          >
            <zuaChangeState></zuaChangeState>
          </div>
          <div class="foot">
            <span>Copyright © 2019 jxjypt.cn All Rights Reserved |</span>
            <a href="https://beian.miit.gov.cn/" target="_blank"
            >京ICP备17043231号</a
            ><br />
            <span>出版物许可证：新出发京零字第海180088号</span>
            <br />
            <span>电信业务经营许可证编号：京B2-20190114 |</span>
            <a
                href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802031480"
                target="_blank"
            >
              京公网安备11010802031480号
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import zuaChangeState from "./components/zuaChangeState";
import qs from "semver";
import router from "../../router";
import Cookies from 'js-cookie';

export default {
  name: "zuaLoginIndex",
  components: {
    zuaChangeState,
  },
  data: function () {
    return {
      arrs: [],
      sex: true,
      logoUrl: "",
      loginUrl: "",
      loginTopStr: "成人高等继续教育学习平台",
      downloadShow: false,
    };
  },
  created() {
    Cookies.set('loginType', '2');
    if (this.$route.query.id) {
      this.getLogo(this.$route.query.id);
    } else {
      let redirect = this.$route.query.redirect;
      if (redirect) {
        const { id } = qs.parse(
            redirect.substring(redirect.indexOf("?id=") + 1, redirect.length)
        );
        this.getLogo(id);
      } else {
        this.getLogo();
      }
    }
  },
  methods: {
    getLogo(id) {
      if (localStorage.getItem("token") && localStorage.getItem("userInfo")) {
        this.axios.get("/biz/home/needDeal/count").then(async (res) => {
          await this.axios.get(`/biz/home/param`).then((res) => {
            if (res.code === 200) {
              // this.homeObj = res.result
              // console.log(this.homeObj,'header')
              this.$store.state.homeObj = res.result;
              localStorage.setItem("homeObj", JSON.stringify(res.result));
            }
          });
          if (res.result) {
            router.replace("/");
          } else {
            router.replace("/todos/list");
          }
        });
      }
      if (id) {
        this.axios.get(`/sys/login/logo?id=${id}`).then((res) => {
          if (res.success) {
            this.logoUrl = res.result.logoUrl || `/static/images/loginlogo.png`;
            this.loginUrl = res.result.loginUrl || `/static/images/loginbg.png`;
            this.loginTopStr =
                res.result.headTitle
            if (res.result.eduName) {
              document.title = `${res.result.eduName} - ${
                  res.result.pageTitle
              }`;
            }
          }
        });
      } else {
        this.logoUrl = `/static/images/loginlogo.png`;
        this.loginUrl = `/static/images/loginbg.png`;
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~styles/varibles.styl';

.page-width {
  width: $pageWidth;
  margin: 0 auto;
}

.loginbg {
  position:relative;
  min-height: 100%;
  height: calc(100vh);
  background: url('../../assets/images/loginbg1.jpg') no-repeat center center;
  .app-down {
    position: fixed;
    top: 50%;
    right: 0
    width: 60px;
    height: 70px;
    background-color: #36AF6C
    cursor: pointer;
    .icon {
      margin-top: 12px;
      margin-left: 18px;
    }
    .down-text {
      color: #fff;
      font-size: 12px;
      text-align: center;
      margin-top: 8px;
    }
  }
  .app-content {
    position: absolute;
    padding: 10px;
    display: flex;
    top: 440px;
    right: 70px;
    width: 330px;
    height: 200px;
    background-color: #fff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    .app-item {
      width: 170px;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .download-code {
        width: 140px;
        height: 140px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .app-text {
        margin-top: 8px;
        font-size: 14px;
        color: #333;
      }
    }
  }
}

.logins {
  width: 786px;
  margin: 0 auto;
  padding-top: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.login-top {
  display: flex;
  justify-content: center;
  align-items: center;
  .login-top-str {
    margin-left: 20px;
    color: #565656;
    font-size: 30px;
  }
}

.mainscontainer {
  margin-top: 30px;
}

.foot, .foot a {
  text-align: center;
  margin-top: 30px;
  line-height: 28px;
  font-size: 0.9rem;
  font-weight: 400;
  color: #9AA1AB;
}
.foot a:hover {
  color: #2979FF;
}
</style>



// WEBPACK FOOTER //
// src/pages/LoginIndex/zuaLoginIndex.vue